/* eslint-disable react/prop-types */
import React from "react";
import { observer } from "mobx-react-lite";
import classes from "./WinnerBanner.module.scss";
import raffleIcon from "../../../assets/images/raffle.png";
import questionsIcon from "../../../assets/images/QUESTIONS.png";
import useWinners from "../Winner/useWinners";

const capitalize = (value) =>
  value ? value.charAt(0).toUpperCase() + value.slice(1) : "";

const buildAddress = (obj) => {
  if (!obj) return "";
  const city = capitalize(obj.city);
  if (!obj.state) return [city, capitalize(obj.country)].filter(Boolean).join(", ");
  const state = obj.state.length <= 2 ? obj.state.toUpperCase() : capitalize(obj.state);
  return [city, state].filter(Boolean).join(", ");
};

const WinnerCard = ({ icon, label, name, subtitle }) => (
  <div className={classes.cardWrapper}>
    <div className={classes.iconWrap}>
      <img src={icon} alt="" />
    </div>
    <div className={classes.card}>
      <div className={classes.labelSection}>
        <span className={classes.label}>{label}</span>
      </div>
      <div className={classes.dividerContainer}>
        <div className={classes.divider} />
      </div>
      <div className={classes.nameSection}>
        <span className={classes.name}>{name}</span>
        {subtitle && <span className={classes.subtitle}>{subtitle}</span>}
      </div>
    </div>
  </div>
);

const WinnerBanner = observer(() => {
  const winners = useWinners();

  // Raffle winner
  let raffleName = null;
  let raffleSubtitle = null;
  let raffleCode = "";
  const hasRaffleWinner = !!winners.raffle?.data?.winner;
  if (hasRaffleWinner) {
    raffleCode = winners.raffle.data.raffle_code || "";
    const w = winners.raffle.data.winner;
    raffleName = `${capitalize(w.first_name)} ${capitalize(w.last_name)}`;
    raffleSubtitle = `from ${buildAddress(w)}`;
  }

  // Most questions winner
  const hasMaorWinner = !!winners.maor?.first_name;
  let maorName = null;
  let maorSubtitle = null;
  if (hasMaorWinner) {
    maorName = `${capitalize(winners.maor.first_name)} ${capitalize(winners.maor.last_name)}`;
    maorSubtitle = `from ${buildAddress(winners.maor)} - ${winners.maor.score} Answers!`;
  }

  if (!hasRaffleWinner && !hasMaorWinner) return null;

  return (
    <div className={classes.container}>
      {hasRaffleWinner && (
        <WinnerCard
          icon={raffleIcon}
          label={<>WINNER RAFFLE{raffleCode ? <><br />#{raffleCode}</> : ""}</>}
          name={raffleName}
          subtitle={raffleSubtitle}
        />
      )}
      {hasMaorWinner && (
        <WinnerCard
          icon={questionsIcon}
          label={<>ANSWERED THE<br />MOST QUESTIONS</>}
          name={maorName}
          subtitle={maorSubtitle}
        />
      )}
    </div>
  );
});

export default WinnerBanner;
